module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_6.669a72aa.svg";